import React from "react";
import Button from "./Button";
import "./ui.css";

// Generic prev/page-count/next control -- modeled on the pager already
// built inline into ComplaintsListPage.jsx (the only working reference in
// the app today), extracted so every other list page can share it instead
// of hand-rolling its own (or having none at all).
export default function Pagination({ page, totalPages, totalItems, pageSize, onPageChange }) {
  if (totalItems === 0) return null;
  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, totalItems);

  return (
    <div className="ui-pagination">
      <span className="ui-pagination-info">
        Showing {start}–{end} of {totalItems}
      </span>
      <div className="ui-pagination-controls">
        <Button variant="secondary" size="sm" disabled={page <= 1} onClick={() => onPageChange(page - 1)} aria-label="Previous page">‹</Button>
        <span className="ui-pagination-page">{page} / {totalPages}</span>
        <Button variant="secondary" size="sm" disabled={page >= totalPages} onClick={() => onPageChange(page + 1)} aria-label="Next page">›</Button>
      </div>
    </div>
  );
}
